import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ADMIN_LEASING_INCOME_SCHEMAS_READ } from 'constants/rightsCodes';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import IconButton from 'components/common/buttons/IconButton';
import LeasingIncomeSchemaContainer from './LeasingIncomeSchemaContainer';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const handleBack = useCallback(() => {
    historyContext.push('/leasingIncomeSchemas');
  }, [historyContext]);

  return (
    <>
      <Portal container={getElemByAreaKey(areas.header)}>
        <FlexBox
          xs={{ direction: 'column', gap: 0, alignItems: 'start' }}
          gap={2}
          justifyContent='space-between'
          alignItems='center'
          grow
          my={1}
        >
          <FlexBox id='leasing-income-schema-title' />
          <FlexBox id='leasing-income-schema-state' mr={2} />
        </FlexBox>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <FlexBox gap={0.5}>
          <IconButton type='backward' onClick={handleBack} size='medium' iconFontSize='medium' />
        </FlexBox>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_INCOME_SCHEMAS_READ}>
        <LeasingIncomeSchemaContainer />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
